export function reloadBootstrapTooltip() {
  if (typeof jQuery === "function") {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }
}
